import { get } from "lodash";
import isV3 from "./is-forms-v3-field";

export default field => {
  if (isV3(field)) {
    return get(field, ["module_field", "settings"], {});
  }
  return field.settings;
};
